import UiField from '@/components/UI/UiField'
import UiCarousel from '@/components/UI/UiCarousel'
import UiDialog from '@/components/UI/UiDialog'
import UiGiftBtn from '@/components/UI/UiGiftBtn'
import UiCounter from '@/components/UI/UiCounter'

export default [
  UiField,
  UiCarousel,
  UiDialog,
  UiGiftBtn,
  UiCounter,
]
